import DataColumns from '@hud/web-components/DataColumns/DataColumns';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import { themeColor } from '@hud/web-components/theme/colors';
import styled from 'styled-components';

export const TitleContainer = styled.div`
  display: flex;
`;
export const TitleIcon = styled(HudIcon)`
  vertical-align: middle;
  position: relative;
  top: -1px;
  color: ${themeColor('turquoise')};
  margin-right: 4px;
`;

export const RightSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const CustomRow = styled(DataColumns.Row)`
  display: flex;
  align-items: start;
  justify-content: start;

  .title {
    width: 115px;
  }

  .value {
    flex: 1;
    max-width: none;
  }
`;

export const SourcesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Source = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
`;
